import * as React from "react"
import { cn } from "~/lib/utils"

const Radio = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type: _type, ...props }, ref) => (
    <input type="radio" className={cn("h-radio", className)} ref={ref} {...props} />
  ),
)
Radio.displayName = "Radio"

export { Radio }
